/**
 * English translations for the application (legacy keys)
 * These mirror the keys in translations/vi.js, but keep values in English
 * so legacy string keys (like 'Loading...') resolve properly when language is 'en'.
 */
const englishTranslations = {
  'Self-Test': 'Self-Test',
  // Common
  'Loading...': 'Loading...',
  'Loading data...': 'Loading data...',
  'Error': 'Error',
  'Cancel': 'Cancel',
  'Save': 'Save',
  'Update': 'Update',
  'Delete': 'Delete',
  'Edit': 'Edit',
  'Actions': 'Actions',
  'Refresh': 'Refresh',
  'Refresh status': 'Refresh status',
  'Search': 'Search',
  'Submit': 'Submit',
  'Created': 'Created',
  'Title': 'Title',
  'Content': 'Content',
  'Create': 'Create',
  'Confirm': 'Confirm',

  // NotesPage
  'Personal Notes': 'Personal Notes',
  'Notes List': 'Notes List',
  'Add New Note': 'Add New Note',
  'Search notes by title or content...': 'Search notes by title or content...',
  'Clear search': 'Clear search',
  "You don't have any notes yet. Create your first note!": "You don't have any notes yet. Create your first note!",
  'Edit Note': 'Edit Note',
  'Enter note title': 'Enter note title',
  'Enter note content': 'Enter note content',
  'Save Note': 'Save Note',
  'Attach Document': 'Attach Document',
  'Supported formats: PDF, Word, Excel': 'Supported formats: PDF, Word, Excel',
  'View document': 'View document',
  'View current document': 'View current document',
  'Image Preview': 'Image Preview',
  'Note Title': 'Note Title',
  'Note Content': 'Note Content',
  'Close': 'Close',
  'Document': 'Document',
  'Current Documents': 'Current Documents',
  'Multiple documents supported': 'Multiple documents supported',
  'Remove document': 'Remove document',

  // Confirmation Dialog
  'Confirm Delete': 'Confirm Delete',
  'Are you sure you want to delete this note? This action cannot be undone.': 'Are you sure you want to delete this note? This action cannot be undone.',
  'Delete Note': 'Delete Note',

  // NotesPageWithSidebar
  'Note Tools': 'Note Tools',
  'Create New Note': 'Create New Note',
  'Statistics': 'Statistics',
  'Total Notes:': 'Total Notes:',

  // Pagination
  'Show': 'Show',
  'items per page': 'items per page',
  'total items': 'total items',
  'Total entries': 'Total entries',
  'First page': 'First page',
  'Previous page': 'Previous page',
  'Next page': 'Next page',
  'Last page': 'Last page',

  // Error messages
  'Cannot load notes': 'Cannot load notes',
  'Cannot create note': 'Cannot create note',
  'Cannot update note': 'Cannot update note',
  'Cannot delete note': 'Cannot delete note',
  'Please enter title and content': 'Please enter title and content',

  // Self-Test Page
  'Self Tests': 'Self Tests',
  'New': 'New',
  'New Test': 'New Test',
  'View': 'View',
  'Create Self-Test': 'Create Self-Test',
  'Test your knowledge and get AI-powered feedback': 'Test your knowledge and get AI-powered feedback',
  'Total Tests': 'Total Tests',
  'Avg Score': 'Avg Score',
  'Self-Test Submission': 'Self-Test Submission',
  'Use Math Editor (LaTeX)': 'Use Math Editor (LaTeX)',
  'Use Math Formula Editor (LaTeX)': 'Use Math Formula Editor (LaTeX)',
  'Type formulas directly': 'Type formulas directly',
  'You can enter formulas with full math symbols. The result will be saved as LaTeX.': 'You can enter formulas with full math symbols. The result will be saved as LaTeX.',
  'Switch on to use the math editor for equations.': 'Switch on to use the math editor for equations.',
  'Type equations like x^2 + y^2 = z^2 or use the toolbar.': 'Type equations like x^2 + y^2 = z^2 or use the toolbar.',
  'Use the math editor to enter your full solution or final expression.': 'Use the math editor to enter your full solution or final expression.',
  'Create New Self-Test': 'Create New Self-Test',
  'Your Self-Tests': 'Your Self-Tests',
  'Subject': 'Subject',
  'Your Question': 'Your Question',
  'Your Answer': 'Your Answer',
  'Upload Images for Question (Optional)': 'Upload Images for Question (Optional)',
  'Upload Images for Answer (Optional)': 'Upload Images for Answer (Optional)',
  'Selected files': 'Selected files',
  'Remove': 'Remove',
  'Submit Self-Test': 'Submit Self-Test',
  'Submitting...': 'Submitting...',
  "You haven't created any self-tests yet.": "You haven't created any self-tests yet.",
  'Question': 'Question',
  'View Details': 'View Details',
  'Self-Test Details': 'Self-Test Details',
  'Question Images': 'Question Images',
  'Answer Images': 'Answer Images',
  'Feedback': 'Feedback',
  'Score': 'Score',
  'Best Parts': 'Best Parts',
  'Needs Improvement': 'Needs Improvement',
  'Advice': 'Advice',
  'Feedback generated at': 'Feedback generated at',
  'Feedback is being generated. Please check back in a few moments.': 'Feedback is being generated. Please check back in a few moments.',
  'Check for feedback now': 'Check for feedback now',
  'Auto-refreshing...': 'Auto-refreshing...',
  'Feedback is now available!': 'Feedback is now available!',
  'Failed to generate feedback. Please try submitting again.': 'Failed to generate feedback. Please try submitting again.',
  'Download PDF': 'Download PDF',
  'Download Feedback as PDF': 'Download Feedback as PDF',
  'Mathematics': 'Mathematics',
  'English': 'English',
  'Literature': 'Literature',
  'Failed to submit self-test': 'Failed to submit self-test',
  'Failed to refresh test': 'Failed to refresh test',
  'Failed to generate PDF': 'Failed to generate PDF',
  'Failed to refresh test status': 'Failed to refresh test status',
  'Submission failed. Try again.': 'Submission failed. Try again.',
  'Pending': 'Pending',
  'Reviewed': 'Reviewed',
  'Failed': 'Failed',
  'Unknown': 'Unknown',
  'Self-test submitted successfully! Feedback will be generated shortly.': 'Self-test submitted successfully! Feedback will be generated shortly.',
  'Please fill in both question and answer fields': 'Please fill in both question and answer fields',
  'Enter your question here...': 'Enter your question here...',
  'Enter your question...': 'Enter your question...',
  'Enter your answer here...': 'Enter your answer here...',
  'Enter your answer...': 'Enter your answer...',
  'Search by subject, question, or answer...': 'Search by subject, question, or answer...',
  'Refresh list': 'Refresh list',
  'No self-tests yet': 'No self-tests yet',
  'Create your first self-test to get AI-powered feedback on your answers': 'Create your first self-test to get AI-powered feedback on your answers',
  'Create your first self-test to get started': 'Create your first self-test to get started',
  'View details': 'View details',
  'Check for feedback': 'Check for feedback',
  'Select Subject': 'Select Subject',
  'Submit your question and answer for AI feedback': 'Submit your question and answer for AI feedback',
  'Click a symbol to insert it': 'Click a symbol to insert it',
  'Type LaTeX here, e.g., x^2 + y^2 = z^2': 'Type LaTeX here, e.g., x^2 + y^2 = z^2',
  'Use the symbols above or type LaTeX directly': 'Use the symbols above or type LaTeX directly',
  'Formula Preview': 'Formula Preview',
  'Type your solution in LaTeX here...': 'Type your solution in LaTeX here...',
  'Submit for Review': 'Submit for Review',
  'Feedback is being generated...': 'Feedback is being generated...',
  'Failed to generate feedback. Please retry later.': 'Failed to generate feedback. Please retry later.',
  'Deleted.': 'Deleted.',
  'Could not delete.': 'Could not delete.',
  'Error refreshing item.': 'Error refreshing item.',
  'Submitted! Feedback will be ready soon.': 'Submitted! Feedback will be ready soon.',
  'You must be logged in to access this page': 'You must be logged in to access this page',
  'Are you sure you want to delete this item? This cannot be undone.': 'Are you sure you want to delete this item? This cannot be undone.',
  'Are you sure you want to delete this self-test? This action cannot be undone.': 'Are you sure you want to delete this self-test? This action cannot be undone.',
  'Delete Self-Test': 'Delete Self-Test',
  'Failed to delete self-test': 'Failed to delete self-test',
  'Self-test deleted successfully': 'Self-test deleted successfully',
  'This feedback was generated using our rule-based system due to AI service rate limits. Try again later for AI-powered feedback.': 'This feedback was generated using our rule-based system due to AI service rate limits. Try again later for AI-powered feedback.',
  'Feedback was generated using rule-based method because the AI service quota has been exceeded. AI-powered feedback will be available when the quota is renewed.': 'Feedback was generated using rule-based method because the AI service quota has been exceeded. AI-powered feedback will be available when the quota is renewed.',
  'Processing feedback... please wait a few minutes': 'Processing feedback... please wait a few minutes',
  'Failed to fetch self-tests': 'Failed to fetch self-tests',

  // Table common (used in Self-Test Page)
  'Status': 'Status',
  'Created At': 'Created At'
};

export default englishTranslations;
